
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { deliveryProduction } from "@/api/api-basic";
// import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class ProductionOrderDevDeliverGoods extends Vue {
  private formInline: objAny = {
    inspectionAndSignature: "",
    logisticsAndNumber: "",
    deliveryRequirements: "",
    projectNamePkId: ""
  };
  private formObj: objAny = {};
  private ruleInline: objAny = {
    deliveryRequirements: [
      {
        required: true,
        message: i18n.t("productionOrder.deliveryRequirementsPl"),
        trigger: "blur"
      }
    ],
    logisticsAndNumber: [
      {
        required: true,
        message: i18n.t("productionOrder.logisticsAndNumberPl"),
        trigger: "blur"
      }
    ],
    inspectionAndSignature: [
      {
        required: true,
        message: i18n.t("productionOrder.inspectionAndSignaturePl"),
        trigger: "blur"
      }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private loading = false;
  public open(item: objAny) {
    this.modalShow = true;
    this.itemData = item;
    this.formInline.projectNamePkId = item.projectNamePkId;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await deliveryProduction(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }

  mounted() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
